/**
 * KAN-811: менеджер (роль MANAGER) ходит только по разрешённым разделам;
 * на остальных уходит на дашборд. Владелец и оператор проходят без изменений.
 * Пока пользователь грузится, ничего не рисуется (страница не шлёт запросов).
 * KAN-854: менеджер с телефона в разделах кабинета, которые есть в приложении,
 * уходит в приложение (/m); ?desktop=1 оставляет в кабинете на 8 часов на устройстве (KAN-884).
 */
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { isManagerUser, isPathAllowedForManager } from '@/lib/managerAccess';
import { mobileRedirectFor, rememberDesktopChoice } from '@/lib/mobileApp';

interface ManagerRouteGuardProps {
  children: React.ReactNode;
}

export function ManagerRouteGuard({ children }: ManagerRouteGuardProps) {
  const { pathname, search } = useLocation();
  // Охранник стоит над всей раскладкой: тесты маршрутов App подменяют useQuery
  // без ответа, поэтому результат читается без деструктуризации.
  const current = useCurrentUser();
  const user = current?.data;

  useEffect(() => {
    rememberDesktopChoice(search);
  }, [search]);

  if (current?.isLoading) {
    return null;
  }

  if (isManagerUser(user)) {
    if (!isPathAllowedForManager(pathname)) {
      return <Navigate to="/" replace />;
    }
    const mobilePath = mobileRedirectFor(pathname, search);
    if (mobilePath) {
      return <Navigate to={mobilePath} replace />;
    }
  }

  return <>{children}</>;
}
